module.exports = __webpack_public_path__ + "static/media/YM16_1.5dd8c3c4.jpg";